import React, {useEffect, useState} from 'react';
import {Controller, useForm} from "react-hook-form";
import {
    Button,
    FormControl,
    FormHelperText,
    Grid,
    InputLabel,
    Modal,
    ModalActions,
    ModalContent,
    ModalTitle
} from "@deere/fuel-react";
import AddIcon from '@material-ui/icons/Add';
import {FormSelect} from "../FormSelect";
import {UserSearch} from "../UserSearch";

export const CampaignStakeholderModal = ({onSave, units, roles}) => {
    const {control, getValues, setValue} = useForm();
    const [open, setOpen] = useState(false);
    const initUser = {
        racfID: "",
        firstName: "",
        lastName: ""
    }
    const [state, setState] = useState({})
    const [, setIsError] = useState(false);
    const [isRoleEmpty, setIsRoleEmpty] = useState(false);
    const [isUserEmpty, setIsUserEmpty] = useState(false);

    const resetState = () => {
        setState({role: {}, unit: {}, user: initUser})
    }

    const filterSelectedData = (list, value) => {
        return list.filter(item => {
            return item.id.toString() === value.toString()
        });
    }

    const handleRoleChange = (event) => {
        if (!isEmptyObject(event.target.value)) {
            setIsRoleEmpty(false)
            setIsError(false)
            setState({
                ...state,
                role: event.target.value
            });
            setValue("role", filterSelectedData(roles, event.target.value)[0])
        }
    }

    const handleUserChange = (event) => {
        if (event.racfID && event.racfID !== "")
        {
            setIsUserEmpty(false)
            setIsError(false)
            setState({
                ...state,
                user: event
            });
            // setValue("user", event)
        }
    }

    const handleUnitChange = (event) => {
        setState({
            ...state,
            unit: event.target.value
        });
        setValue("unit", filterSelectedData(units, event.target.value)[0])
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        resetState()
    };

    const isEmptyObject = (data) => {
        return !data || Object.keys(data).length === 0
    }

    const handleSave = () => {
        const data = getValues()
        if (isEmptyObject(data.role) || data.user.racfID === "") {
            setIsError(true)
            if (isEmptyObject(data.role)) setIsRoleEmpty(true)
            if (data.user.racfID === "") setIsUserEmpty(true)
        } else {
            setOpen(false);
            setIsUserEmpty(false)
            setIsRoleEmpty(false)
            setIsError(false)
            onSave(data)
            resetState()
        }
    }
    useEffect(() => {
        setState({role: {}, unit: {}, user: initUser}) // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <Button variant="secondary" onClick={handleClickOpen} startIcon={<AddIcon/>}> Add Stakeholder </Button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-Modal-title"
                aria-describedby="alert-Modal-description"
                maxWidth="sm"
                fullWidth={true}
            >
                <ModalTitle onClose={handleClose} id="alert-Modal-title">
                    Add Stakeholder
                </ModalTitle>
                <ModalContent>
                    <form>
                        <Grid container alignItems="center" spacing={4}>
                            <Grid item xs={12}>
                                <FormControl required fullWidth error>
                                    <InputLabel htmlFor="stakeholder">
                                        Stakeholder Name
                                    </InputLabel>
                                    <Controller
                                        rules={{required: true}}
                                        control={control}
                                        defaultValue={state.user}
                                        value={state.user}
                                        name="user"
                                        render={({onChange, value}) => (
                                            <UserSearch
                                                defValue={state.user}
                                                onOptionsChange={(e) => {
                                                    onChange(e)
                                                    handleUserChange(e)
                                                }}
                                                rowID={-1}/>
                                        )}
                                    />
                                    <FormHelperText>{isUserEmpty && "Please search a User"}</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormSelect
                                    label={"role-label"}
                                    defValue={state.role}
                                    name={"role"}
                                    options={roles}
                                    onTypeChange={handleRoleChange}
                                    control={control}
                                    required={true}
                                    isError={isRoleEmpty}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormSelect
                                    label={"unit-label"}
                                    defValue={state.unit}
                                    name={"unit"}
                                    options={units}
                                    onTypeChange={handleUnitChange}
                                    control={control}
                                    required={false}
                                />
                            </Grid>
                        </Grid>
                    </form>
                </ModalContent>
                <ModalActions>
                    <Button onClick={handleClose} variant="secondary">
                        Cancel
                    </Button>
                    <Button onClick={() => handleSave()} variant="primary">
                        Add
                    </Button>
                </ModalActions>
            </Modal>
        </div>
    );
};